<template>
    <div class="game-selector">
        <primevue-button
            class="play-game-btn plain-btn"
            @click="showGameModal = true"
        >
            <font-awesome-icon :icon="['fas', 'circle-play']" />
            Play Frequency Runner
        </primevue-button>
        <prime-dialog
            v-model:visible="showGameModal"
            modal
            dismissable-mask
            :draggable="false"
            :style="{ width: 'min(96vw, 920px)' }"
            header="&#9889; Frequency Runner"
            @hide="onModalHide"
        >
            <spark-runner-game v-if="showGameModal" :in-modal="true" />
        </prime-dialog>
    </div>
</template>

<script setup lang="ts">
import PrimevueButton from 'primevue/button';
import PrimeDialog from 'primevue/dialog';
import SparkRunnerGame from '@/components/layout/SparkRunnerGame.vue';
import { ref } from 'vue';

const showGameModal = ref<boolean>(false);

function onModalHide (): void {
    showGameModal.value = false;
}
</script>

<style lang="scss" scoped>
.game-selector {
    display: flex;
    justify-content: center;
}
</style>
